export enum FreightOrderDetailActionTypes {
  FREIGHT_ORDER_DETAIL_RECEIVED = "FREIGHT_ORDER_DETAIL_RECEIVED",
  FREIGHT_ORDER_DETAIL_ERRORED = "FREIGHT_ORDER_DETAIL_RECEIVED",
  FREIGHT_ORDER_TRACKING_RECEIVED = "FREIGHT_ORDER_TRACKING_RECEIVED",
  FREIGHT_ORDER_TRACKING_ERRORED = "FREIGHT_ORDER_TRACKING_ERRORED",
  FREIGHT_BOL_RECEIVED = "FREIGHT_BOL_RECEIVED",
}
